// Funzioni per la generazione dei template ( e parti di essi) per la firma XML
// con i gli algoritmi aggiornati

function getSignedProperties(serialNumber, issuerName, encodedDigest) {
  let signedProperties =
    '<xades:SignedProperties xmlns:ds="http://www.w3.org/2000/09/xmldsig#" xmlns:xades="http://uri.etsi.org/01903/v1.3.2#" Id="EncryptedBallotSignatureSignedProperties">\n' +
    "					<xades:SignedSignatureProperties>\n" +
    "						<xades:SigningCertificate>\n" +
    "							<xades:Cert>\n" +
    "								<xades:CertDigest>\n" +
    '									<ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"></ds:DigestMethod>\n' +
    "									<ds:DigestValue>" +
    encodedDigest +
    "</ds:DigestValue>\n" +
    "								</xades:CertDigest>\n" +
    "								<xades:IssuerSerial>\n" +
    "									<ds:X509IssuerName>" +
    issuerName +
    "</ds:X509IssuerName>\n" +
    "									<ds:X509SerialNumber>" +
    serialNumber +
    "</ds:X509SerialNumber>\n" +
    "								</xades:IssuerSerial>\n" +
    "							</xades:Cert>\n" +
    "						</xades:SigningCertificate>\n" +
    "					</xades:SignedSignatureProperties>\n" +
    "					<xades:SignedDataObjectProperties>\n" +
    '						<xades:DataObjectFormat ObjectReference="#r-id-encrypted-ballot">\n' +
    "							<xades:MimeType>application/xml</xades:MimeType>\n" +
    "						</xades:DataObjectFormat>\n" +
    '						<xades:DataObjectFormat ObjectReference="#r-id-key-info">\n' +
    "							<xades:MimeType>application/xml</xades:MimeType>\n" +
    "						</xades:DataObjectFormat>\n" +
    "					</xades:SignedDataObjectProperties>\n" +
    "				</xades:SignedProperties>";
  // console.log(signedProperties);
  return signedProperties;
}
function getKeyInfo(certStr) {
  let keyInfo =
    '<ds:KeyInfo xmlns:ds="http://www.w3.org/2000/09/xmldsig#" Id="EncryptedBallotSignatureKeyInfo">\n' +
    "			<ds:X509Data>\n" +
    "				<ds:X509Certificate>\n" +
    certStr +
    "</ds:X509Certificate>\n" +
    "			</ds:X509Data>\n" +
    "		</ds:KeyInfo>";

  return keyInfo;
}
function getSignedInfo(encryptedBallotDigestValue, signedProperties, keyInfo) {
  let signedInfoTemplate =
    '<ds:SignedInfo xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n' +
    '			<ds:CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></ds:CanonicalizationMethod>\n' +
    '			<ds:SignatureMethod Algorithm="http://www.w3.org/2001/04/xmldsig-more#rsa-sha256"></ds:SignatureMethod>\n' +
    '			<ds:Reference Id="r-id-encrypted-ballot" URI="#EncryptedBallot">\n' +
    "				<ds:Transforms>\n" +
    '					<ds:Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315#WithComments"></ds:Transform>\n' +
    "				</ds:Transforms>\n" +
    '				<ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"></ds:DigestMethod>\n' +
    "				<ds:DigestValue>" +
    encryptedBallotDigestValue +
    "</ds:DigestValue>\n" +
    "			</ds:Reference>\n" +
    '			<ds:Reference Type="http://uri.etsi.org/01903#SignedProperties" URI="#EncryptedBallotSignatureSignedProperties">\n' +
    "				<ds:Transforms>\n" +
    '					<ds:Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></ds:Transform>\n' +
    "				</ds:Transforms>\n" +
    '				<ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"></ds:DigestMethod>\n' +
    "				<ds:DigestValue>" +
    signedProperties +
    "</ds:DigestValue>\n" +
    "			</ds:Reference>\n" +
    '			<ds:Reference Id="r-id-key-info" URI="#EncryptedBallotSignatureKeyInfo">\n' +
    "				<ds:Transforms>\n" +
    '					<ds:Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315#WithComments"></ds:Transform>\n' +
    "				</ds:Transforms>\n" +
    '				<ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"></ds:DigestMethod>\n' +
    "				<ds:DigestValue>" +
    keyInfo +
    "</ds:DigestValue>\n" +
    "			</ds:Reference>\n" +
    "		</ds:SignedInfo>";
  // console.log(signedInfoTemplate);

  return signedInfoTemplate;
}
function getSignatureTemplate(
  signedInfoTemplate,
  voteToSign,
  CertificateValueDigestValue,
  CertificateValueIssuer,
  CertificateValueSerialNumber,
  EncryptedBallotSignatureValue,
  CertificateValue
) {
  let template =
    "<Envelope>\n" +
    '	<ds:Signature xmlns:ds="http://www.w3.org/2000/09/xmldsig#" Id="EncryptedBallotSignature">' +
    signedInfoTemplate +
    '<ds:SignatureValue Id="EncryptedBallotSignatureValue">\n' +
    EncryptedBallotSignatureValue +
    "</ds:SignatureValue>" +
    '<ds:KeyInfo xmlns:ds="http://www.w3.org/2000/09/xmldsig#" Id="EncryptedBallotSignatureKeyInfo">\n' +
    "			<ds:X509Data>\n" +
    "				<ds:X509Certificate>\n" +
    CertificateValue +
    "</ds:X509Certificate>\n" +
    "			</ds:X509Data>\n" +
    "		</ds:KeyInfo>\n" +
    voteToSign +
    '			<ds:Object><xades:QualifyingProperties xmlns:xades="http://uri.etsi.org/01903/v1.3.2#" Target="#EncryptedBallot">\n' +
    '				<xades:SignedProperties xmlns:ds="http://www.w3.org/2000/09/xmldsig#" xmlns:xades="http://uri.etsi.org/01903/v1.3.2#" Id="EncryptedBallotSignatureSignedProperties">\n' +
    "					<xades:SignedSignatureProperties>\n" +
    "						<xades:SigningCertificate>\n" +
    "							<xades:Cert>\n" +
    "								<xades:CertDigest>\n" +
    '									<ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"/>\n' +
    "									<ds:DigestValue>" +
    CertificateValueDigestValue +
    "</ds:DigestValue>\n" +
    "								</xades:CertDigest>\n" +
    "								<xades:IssuerSerial>\n" +
    "									<ds:X509IssuerName>" +
    CertificateValueIssuer +
    "</ds:X509IssuerName>\n" +
    "									<ds:X509SerialNumber>" +
    CertificateValueSerialNumber +
    "</ds:X509SerialNumber>\n" +
    "								</xades:IssuerSerial>\n" +
    "							</xades:Cert>\n" +
    "						</xades:SigningCertificate>\n" +
    "					</xades:SignedSignatureProperties>\n" +
    "					<xades:SignedDataObjectProperties>\n" +
    '						<xades:DataObjectFormat ObjectReference="#r-id-encrypted-ballot">\n' +
    "							<xades:MimeType>application/xml</xades:MimeType>\n" +
    "						</xades:DataObjectFormat>\n" +
    '						<xades:DataObjectFormat ObjectReference="#r-id-key-info">\n' +
    "							<xades:MimeType>application/xml</xades:MimeType>\n" +
    "						</xades:DataObjectFormat>\n" +
    "					</xades:SignedDataObjectProperties>\n" +
    "				</xades:SignedProperties>\n" +
    "			</xades:QualifyingProperties></ds:Object>\n" +
    "	</ds:Signature>\n" +
    "</Envelope>";
  return template;
}
export { getSignedProperties, getKeyInfo, getSignedInfo, getSignatureTemplate };
